<template>
  <a-modal
    width="40%"
    :title="$t('审核')"
    :visible="open"
    :confirm-loading="submitLoading"
    @cancel="onClose"
    @close="onClose"
    @ok="submitForm"
  >
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('审核结果')" prop="videoStatus">
        <a-radio-group v-model="form.videoStatus" button-style="solid">
          <a-radio-button :value="3">{{ $t('审核通过') }}</a-radio-button>
          <a-radio-button :value="2">{{ $t('未通过') }}</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="form.videoStatus === 2" :label="$t('审核意见')" prop="auditReason">
        <a-textarea
          v-model="form.auditReason"
          :rows="4"
          :maxLength="200"
          :placeholder="$t('请输入') + $t('审核意见')"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { auditCommunityVideo } from '@/api/community/video'

export default {
  name: 'AuditForm',
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      open: false,
      form: {
        idList: [],
        videoStatus: 3,
        auditReason: null
      },
      rules: {
        videoStatus: [
          { required: true, message: this.$t('审核结果') + this.$t('不能为空'), trigger: 'change' }
        ],
        auditReason: [
          {
            validator: (rule, value, callback) => {
              if (this.form.videoStatus === 2 && !value) {
                callback(new Error(this.$t('审核意见') + this.$t('不能为空')))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        idList: [],
        videoStatus: 3,
        auditReason: null
      }
    },
    /** 审核按钮操作 */
    handleAudit (ids) {
      this.reset()
      this.form.idList = Array.isArray(ids) ? ids : [ids]
      this.open = true
    },
    /** 提交按钮 */
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        auditCommunityVideo(this.form).then(() => {
          this.$message.success(this.$t('审核成功'), 3)
          this.open = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
